import { fade, makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  backRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    width: "100%",
  },
  backTitle: {
    color: grey[800],
    fontSize: 18,
  },
  emptyText: {
    color: grey[700],
    textAlign: "center",
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  rowCard: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    width: "100%",
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    backgroundColor: grey[50],
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 40,
    height: 40,
    borderRadius: theme.spacing(1),
    backgroundColor: fade(theme.palette.primary.main, 0.08),
  },
  rowContent: {
    flex: 1,
    minWidth: 0,
  },
  rowTitle: {
    color: theme.palette.common.black,
    fontSize: 16,
  },
  rowSubtitle: {
    color: grey[500],
    fontSize: 12,
  },
  step: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
    width: "100%",
  },
  helper: {
    color: grey[700],
    fontSize: 14,
    textAlign: "center",
  },
  actionsRow: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(1),
    width: "100%",
  },
  alertWrapper: {
    width: "100%",
  },
  alertInset: {
    paddingInline: theme.spacing(4),
  },
}));
